import { useCallback } from "react";
import { useHotkeysContext } from "react-hotkeys-hook";

/**
 * Hook that provides a function to check if a hotkey scope is currently enabled.
 * Useful for gating raw window.addEventListener handlers by scope.
 */
export const useIsHotkeyScopeEnabled = () => {
  const { activeScopes } = useHotkeysContext();

  const isScopeEnabled = useCallback(
    (scope: string): boolean => {
      return activeScopes.includes(scope);
    },
    [activeScopes]
  );

  return { isScopeEnabled, activeScopes };
};
